<section class="asset-management-section">
  <ts-page-header [displaySeparationBorder]="true">
    <p page-header-title class="font-ts-header-title text-ts-header-title">Trailing Income Statement</p>

    <div page-header-action-bar class="w-full flex flex-row items-center justify-start gap-2">
      <report-period-selector
        [loading]="loading()"
        [reportPeriod]="reportPeriod()"
        (reportPeriodChanged)="reportPeriodChanged.next($event)"
      />
    </div>
  </ts-page-header>

  <ag-grid-angular
    class="ag-theme-quartz"
    [rowData]="flattenedTrailingIncomeStatement()"
    [autoGroupColumnDef]="autoGroupColumnDef"
    [treeData]="true"
    [getDataPath]="getDataPath"
    [columnDefs]="trailingIncomeStatementColDefs()"
    [gridOptions]="gridOptions"
    (gridReady)="onGridReady($event)"
  ></ag-grid-angular>
</section>
